import type { GetHookResponse } from '../hooks'
import type { SelectItem } from '../types'
import { useActiveRubric } from './active'
import { useMemo } from 'react'

export const useSkillShareCategories = (): GetHookResponse<SelectItem[]> => {
  const { data, ...query } = useActiveRubric()
  const categories = useMemo(
    () => data?.categories?.filter((c) => c.skillShare).map((c) => ({ label: c.title, value: c.code })),
    [data?.categories]
  )

  return { ...query, data: categories }
}
